import React from 'react';
import { motion } from 'framer-motion';
interface PullQuoteProps {
  children: React.ReactNode;
  delay?: number;
}
export function PullQuote({
  children,
  delay = 0
}: PullQuoteProps) {
  return <motion.div initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-20px',
    amount: 0.2
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="my-10 md:my-16 py-5 md:py-6 px-5 md:px-8 bg-[#6B5D52] border-l-4 border-[#C87941] rounded-lg shadow-xl" data-id="element-45">
      <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-white text-center italic leading-relaxed" data-id="element-46">
        {children}
      </p>
    </motion.div>;
}